// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CopyCostsModal_SaveBidContractMutationVariables = Types.Exact<{
  input: Types.SaveBidContractInput;
}>;


export type CopyCostsModal_SaveBidContractMutation = { __typename?: 'Mutation', saveBidContract: { __typename?: 'SaveBidContractResult', bidContract: { __typename?: 'BidContract', id: string } } };

export type CopyCostsModal_CopyPlanBasedBidCostsMutationVariables = Types.Exact<{
  input: Types.CopyPlanBasedBidCostsInput;
}>;


export type CopyCostsModal_CopyPlanBasedBidCostsMutation = { __typename?: 'Mutation', copyPlanBasedBidCosts: { __typename?: 'CopyPlanBasedBidCostsResult', bidContract: { __typename?: 'BidContract', id: string } } };


export const CopyCostsModal_SaveBidContractDocument = gql`
    mutation CopyCostsModal_SaveBidContract($input: SaveBidContractInput!) {
  saveBidContract(input: $input) {
    bidContract {
      id
    }
  }
}
    `;
export type CopyCostsModal_SaveBidContractMutationFn = Apollo.MutationFunction<CopyCostsModal_SaveBidContractMutation, CopyCostsModal_SaveBidContractMutationVariables>;

/**
 * __useCopyCostsModal_SaveBidContractMutation__
 *
 * To run a mutation, you first call `useCopyCostsModal_SaveBidContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyCostsModal_SaveBidContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyCostsModalSaveBidContractMutation, { data, loading, error }] = useCopyCostsModal_SaveBidContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyCostsModal_SaveBidContractMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CopyCostsModal_SaveBidContractMutation, CopyCostsModal_SaveBidContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CopyCostsModal_SaveBidContractMutation, CopyCostsModal_SaveBidContractMutationVariables>(CopyCostsModal_SaveBidContractDocument, options);
      }
export type CopyCostsModal_SaveBidContractMutationHookResult = ReturnType<typeof useCopyCostsModal_SaveBidContractMutation>;
export type CopyCostsModal_SaveBidContractMutationResult = Apollo.MutationResult<CopyCostsModal_SaveBidContractMutation>;
export type CopyCostsModal_SaveBidContractMutationOptions = Apollo.BaseMutationOptions<CopyCostsModal_SaveBidContractMutation, CopyCostsModal_SaveBidContractMutationVariables>;
export const CopyCostsModal_CopyPlanBasedBidCostsDocument = gql`
    mutation CopyCostsModal_CopyPlanBasedBidCosts($input: CopyPlanBasedBidCostsInput!) {
  copyPlanBasedBidCosts(input: $input) {
    bidContract {
      id
    }
  }
}
    `;
export type CopyCostsModal_CopyPlanBasedBidCostsMutationFn = Apollo.MutationFunction<CopyCostsModal_CopyPlanBasedBidCostsMutation, CopyCostsModal_CopyPlanBasedBidCostsMutationVariables>;

/**
 * __useCopyCostsModal_CopyPlanBasedBidCostsMutation__
 *
 * To run a mutation, you first call `useCopyCostsModal_CopyPlanBasedBidCostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyCostsModal_CopyPlanBasedBidCostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyCostsModalCopyPlanBasedBidCostsMutation, { data, loading, error }] = useCopyCostsModal_CopyPlanBasedBidCostsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyCostsModal_CopyPlanBasedBidCostsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CopyCostsModal_CopyPlanBasedBidCostsMutation, CopyCostsModal_CopyPlanBasedBidCostsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CopyCostsModal_CopyPlanBasedBidCostsMutation, CopyCostsModal_CopyPlanBasedBidCostsMutationVariables>(CopyCostsModal_CopyPlanBasedBidCostsDocument, options);
      }
export type CopyCostsModal_CopyPlanBasedBidCostsMutationHookResult = ReturnType<typeof useCopyCostsModal_CopyPlanBasedBidCostsMutation>;
export type CopyCostsModal_CopyPlanBasedBidCostsMutationResult = Apollo.MutationResult<CopyCostsModal_CopyPlanBasedBidCostsMutation>;
export type CopyCostsModal_CopyPlanBasedBidCostsMutationOptions = Apollo.BaseMutationOptions<CopyCostsModal_CopyPlanBasedBidCostsMutation, CopyCostsModal_CopyPlanBasedBidCostsMutationVariables>;